export const type = 'form.checkbox';
